export const UPLOAD_ENDED = 'app/UPLOAD_ENDED';

export const uploadEnded = payload => ({
  type: UPLOAD_ENDED,
  payload,
});



// WEBPACK FOOTER //
// ./app/actions/upload-ended.js